import { useSyncExternalStore } from 'react';
import { themeStore, type ThemePreference, type ThemeSnapshot } from './theme';

/**
 * O tema da vez, e como mudá-lo.
 *
 * Uma loja só, lida por `useSyncExternalStore`: o seletor no menu e os avisos no canto
 * (`AppToaster`) enxergam a mesma escolha sem um provedor no meio — tema é estado do
 * aparelho, não da árvore de componentes.
 */
export function useTheme(): ThemeSnapshot & {
  setPreference: (preference: ThemePreference) => void;
} {
  const snapshot = useSyncExternalStore(
    themeStore.subscribe,
    themeStore.getSnapshot,
    themeStore.getSnapshot,
  );
  return { ...snapshot, setPreference: themeStore.setPreference };
}
